import axios from 'axios'
import { normalize } from 'normalizr'
import { isEmpty } from 'lodash'

import { ACTION_TYPES } from 'store/common/constants/actionsTypes'
import { API } from 'utils/helpers/api/api'
import { formatRequestString, formatQueryString } from 'utils/helpers/api/queryString'

export const makeFetchItemActionCreator =
  ({ entityUrl, entityKey, entitySchema, transformResponseFunction = data => data }) =>
  (params, options = {}) =>
  dispatch => {
    const { id } = params
    const { isRequestCancelable = true, catchAxiosErrors = true } = options
    const requestString = formatRequestString({ entityUrl, params })
    const requestQueryString = formatQueryString(params)
    const requestUrl = isEmpty(requestQueryString) ? requestString : `${requestString}?${requestQueryString}`
    const request = API.makeRequest({ type: 'get', requestUrl, isRequestCancelable })

    dispatch({
      type: ACTION_TYPES.ITEM_FETCH_START,
      data: {
        id,
      },
    })

    const preparedRequest = request
      .then(payload => {
        const dataTransformed = transformResponseFunction(payload.data, params)
        const data = normalize({ [entityKey]: [dataTransformed] }, { [entityKey]: [entitySchema] })

        dispatch({
          type: ACTION_TYPES.ITEM_FETCH_SUCCESS,
          data,
        })

        return dataTransformed
      })
      .catch(error => {
        dispatch({
          type: ACTION_TYPES.ITEM_FETCH_FAIL,
          data: {
            id,
            error,
          },
        })

        // Catch and ignore cancellation errors
        // NOTE: Axios cancellation errors should always be caught either here or in a handler
        // that dispatches the action. Otherwise webpack starts reloading chunks
        if (!catchAxiosErrors || !axios.isCancel(error)) {
          return Promise.reject(error)
        }
      })

    preparedRequest.getCancellationData = request.getCancellationData

    return preparedRequest
  }
